import { useAppSelector } from 'dux/app/hooks';

import { theme } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';

import { Image } from 'Components/Image';
import { Pricing } from 'Components/Pricing';
import { Typography } from 'Components/Typography';

import { productsCategories, productsSlugs } from 'constants/products';

import SliderAndContent from 'Blocks/SliderAndContent';

import { productStylingGelContent as content } from 'assets/content/landingPages/stylingGel';
import checkIcon from 'assets/images/check.svg';

import useResponsiveVariant from 'utils/useResponsiveVariant';

import { getProductPricesContentFromAPI } from 'dux/products/selectors';
import { useFetchProductsList } from 'dux/products/hooks';

import { CTA } from './CTA';

const SectionContainer = styled('div')`
  width: 100vw;
  background: ${theme.colors.neutral[200]};
`;

const ProductDescriptionTextContainer = styled('div')`
  padding: ${legacyTheme.spacing.s48} ${legacyTheme.spacing.s24} ${legacyTheme.spacing.s32};

  ${legacyTheme.breakpoints.up('sm')} {
    padding: ${legacyTheme.spacing.s12} ${legacyTheme.spacing.s12} 0 ${legacyTheme.spacing.s12};
  }
`;

const StyledTextSubTitle = styled(Typography)`
  padding: ${legacyTheme.spacing.s24} 0;
`;
const ProductDescriptionList = styled('ul')`
  list-style-type: none;
  text-decoration: none;
  padding: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 12px;

  grid-template-rows: auto auto auto;
  min-height: 113px;
`;
const ProductDescriptionListItem = styled('li')`
  display: grid;
  grid-template-columns: 12px auto;
  grid-column-gap: 12px;
  grid-template-rows: auto;
`;
const StyledTextBenefit = styled(Typography)`
  font-size: 14px;
  margin: 0 !important;
`;
const CheckIconWrapper = styled('div')`
  width: 12px;
  height: 12px;
  position: relative;
  top: -2px;
`;

const StyledButton = styled(CTA)`
  width: 100%;
`;

export const ProductStylingGelSection = () => {
  const { headline, subHead, productCapacity, benefits, images, ctaText } = content;
  const { isMobile } = useResponsiveVariant();
  const { isLoaded } = useFetchProductsList();

  const stylingGelPricesContentFromAPI = useAppSelector((state) =>
    getProductPricesContentFromAPI(state, {
      productSlug: productsSlugs.STYLING_GEL,
    }),
  );

  // default values are never used since we don't show pricing as long as the API is not loaded
  const { price, subscribed_price, currency } = stylingGelPricesContentFromAPI ?? {
    price: 0,
    subscribed_price: 0,
    currency: 'USD',
  };
  return (
    <SectionContainer>
      <ProductDescriptionTextContainer>
        {/* @ts-expect-error SliderAndContent is not typed yet */}
        <SliderAndContent isCover sliderDataFrom="lp-styling-gel" slides={images} textPadding={8}>
          <div>
            <Typography align="center" variant="h1r-mono">
              {headline}
            </Typography>

            <StyledTextSubTitle align="center">{subHead}</StyledTextSubTitle>
            <ProductDescriptionList>
              {benefits.map((benefit) => (
                <ProductDescriptionListItem key={benefit}>
                  <CheckIconWrapper>
                    <Image alt="✓" height="9" src={checkIcon} width="14" />
                  </CheckIconWrapper>

                  <StyledTextBenefit align="left" paragraph variant="p2">
                    {benefit}
                  </StyledTextBenefit>
                </ProductDescriptionListItem>
              ))}
            </ProductDescriptionList>

            <Typography align="center" paragraph variant="p2">
              {productCapacity}
            </Typography>
            {isLoaded && (
              <Pricing
                currency={currency}
                price={price}
                priceWithSubscription={subscribed_price}
                productCategory={productsCategories.HAIRCARE}
                showDiscountModal
              />
            )}
            {!isMobile && (
              <StyledButton dataFrom="product-module" variant="vert">
                {ctaText}
              </StyledButton>
            )}
          </div>
        </SliderAndContent>
      </ProductDescriptionTextContainer>
    </SectionContainer>
  );
};
